import React, { useState, useEffect } from "react";
import "./gallery.css";
import gallery2 from "./assets/galleryImages/gallery2.JPG";
import gallery16 from "./assets/galleryImages/gallery16.jpg";
import gallery19 from "./assets/galleryImages/gallery19.jpeg";
import gallery9 from "./assets/galleryImages/gallery9.JPG";
import gallery21 from "./assets/galleryImages/gallery21.JPG";
import gallery22 from "./assets/galleryImages/gallery22.JPG";
import gallery13 from "./assets/galleryImages/gallery13.JPG";
import gallery14 from "./assets/galleryImages/gallery14.jpeg";
import gallery12 from "./assets/galleryImages/gallery12.jpeg";
import gallery18 from "./assets/galleryImages/gallery18.jpg";
import gallery5 from "./assets/galleryImages/gallery5.JPG";
import gallery4 from "./assets/galleryImages/gallery4.JPG";
import redScribble from "./assets/redScribble.png";
import redScribble2 from "./assets/redScribble2.png";
import redLoop from "./assets/redLoop.png";
import yellowStars from "./assets/yellowStars.png";
import yellowDrop from "./assets/yellowDrop.png";

import yellowScribble from "./assets/yellowScribble.png";
import redSwirls from "./assets/redSwirls.png";
import stars from "./assets/stars.png";

import Header from "../header/header";
import Insta from "./insta";
import Loading from "components/loading/loading";
import * as galleryService from "../../services/gallery-service";

function Gallery() {
  const [gallery, setGallery] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const fetchGallery = async () => {
    setIsLoading(true);
    const response = await galleryService.fetchGallery();
    setGallery(response.data);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchGallery();
  }, []);
  return (
    <div className="main">
      <Header />
      <div className="gallery-container">
        <div className="images">
          <img className="gallery1" src={gallery16} alt="Gallery 1" />
          <img className="gallery2" src={gallery19} alt="Gallery 2" />
          <img className="gallery3" src={gallery2} alt="Gallery 3" />
          <img className="gallery4" src={gallery9} alt="Gallery 4" />
          <img className="gallery5" src={gallery21} alt="Gallery 5" />
          <img className="gallery6" src={gallery22} alt="Gallery 6" />
          <img className="gallery7" src={gallery13} alt="Gallery 7" />

          <img className="gallery8" src={gallery14} alt="Gallery 8" />
          <img className="gallery9" src={gallery12} alt="Gallery 9" />

          <img className="gallery10" src={gallery18} alt="Gallery 10" />

          <img className="gallery11" src={gallery5} alt="Gallery 11" />

          <img className="gallery12" src={gallery4} alt="Gallery 12" />
          <img className="redLoop" src={redLoop} alt="redLoop" />
          <img className="yellowStars" src={yellowStars} alt="yellowStars" />
          <img className="yellowDrop" src={yellowDrop} alt="yellowDrop" />
          <img className="redScribble" src={redScribble} alt="redScribble" />
          <img className="redScribble2" src={redScribble2} alt="redScribble2" />
          <img
            className="yellowScribble"
            src={yellowScribble}
            alt="yellowScribble"
          />
          <img className="redSwirls" src={redSwirls} alt="redSwirls" />
          <img className="stars" src={stars} alt="stars" />
        </div>
      </div>
      {!isLoading ? (
        <div className="beige">
          {gallery && <iframe className="youtube" src={gallery.video}></iframe>}
          <h2>Check us out</h2>
          <Insta />
        </div>
      ) : (
        <Loading></Loading>
      )}
    </div>
  );
}

export default Gallery;
